export enum ServiceWorkerAudioProxyKeys {
    Succeeded = 'Succeeded',
    IdentityType = 'IdentityType',
    FailureReason = 'FailureReason',
}
